<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';

  export let tenant;

  let historico = [];
  let isLoading = false;
  let carregandoHistorico = true;

  let codigoCupom = '';
  let loadingCupom = false;
  let mensagemCupom = '';
  let sucessoCupom = false;

  let cupomAplicado = null;
  let valorDesconto = 0;

  let historicoCupons = [];
  let carregandoCupons = true;

  let planos = [];
  let planoSelecionado = '';
  let planoAtual = null;
  let carregandoPlanos = true;
  let ehClienteNovo = false;
  let planosComDesconto = [];
  let cpfCompra = '';

  // planos e planoSelecionado citados para o Svelte recalcular quando mudarem (antes só rodava uma vez e o botão não mostrava os dias)
  $: planoAtual = (planos, planoSelecionado, obterPlanoAtual());
  $: {
    const cpfAtual = String(tenant?.cpf || '').trim();
    if (cpfAtual && cpfCompra !== cpfAtual) {
      cpfCompra = cpfAtual;
    }
  }

  onMount(() => {
    buscarHistorico();
    buscarCuponsResgatados();
    carregarPlanos();
  });

  async function carregarPlanos() {
    carregandoPlanos = true;

    try {
      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_obter_valores, { body: { id_tenant: tenant ? tenant.id : null } });

      if (res && res.sucesso && Array.isArray(res.plans) && res.plans.length > 0) {
        planos = res.plans;
        ehClienteNovo = !!res.eh_cliente_novo;
      } else {
        planos = [];
        ehClienteNovo = false;
      }

      // Calcula preços com desconto de cliente novo (se aplicável)
      planosComDesconto = planos.map(p => {
        const desconto = parseFloat(p.desconto_cliente_novo || 0) || 0;
        const valor = parseFloat(p.valor || 0) || 0;
        return {
          ...p,
          desconto_cliente_novo: desconto,
          valorComDesconto: Math.max(0.10, +(valor - desconto).toFixed(2)),
          temDescontoClienteNovo: desconto > 0
        };
      });

      if (planos.length > 0 && !planos.find((plano) => plano.id === planoSelecionado)) {
        planoSelecionado = planos[0].id;
      }
    } catch (e) {
      console.error('Erro ao carregar planos de crédito:', e);
      planos = [];
      planosComDesconto = [];
      ehClienteNovo = false;
    } finally {
      carregandoPlanos = false;
    }
  }

  async function buscarCuponsResgatados() {
    if (!tenant) return;
    try {
      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_listar_cupons_resgatados, {
        body: { id_tenant: tenant.id }
      });
      if (res && res.sucesso) {
        historicoCupons = res.cupons;
      }
    } catch (e) {
      console.error('Erro ao buscar cupons:', e);
    } finally {
      carregandoCupons = false;
    }
  }

  async function aplicarCupom() {
    if (!codigoCupom.trim()) return;
    loadingCupom = true;
    mensagemCupom = '';

    try {
      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_aplicar_cupom, {
        body: { id_tenant: tenant.id, codigo: codigoCupom }
      });

      if (res && res.sucesso) {
        sucessoCupom = true;
        mensagemCupom = res.mensagem;

        await buscarCuponsResgatados();

        if (res.tipo === 'dias') {
          codigoCupom = '';
          setTimeout(() => { window.location.reload(); }, 2000);
        } else if (res.tipo === 'desconto') {
          cupomAplicado = res.codigo;
          valorDesconto = parseFloat(res.valor_desconto);
          codigoCupom = '';
        }
      } else {
        sucessoCupom = false;
        mensagemCupom = res && res.mensagem ? res.mensagem : 'Erro ao validar cupom.';
        cupomAplicado = null;
        valorDesconto = 0;
      }
    } catch (e) {
      sucessoCupom = false;
      mensagemCupom = 'Erro de conexão com o servidor.';
    } finally {
      loadingCupom = false;
    }
  }

  async function buscarHistorico() {
    if (!tenant) return;
    const conexao = new Conexoes();
    const res = await conexao.conecta(Constantes.api_listar_pagamentos, {
      body: { id_tenant: tenant.id }
    });
    if (res && res.sucesso) {
      historico = res.historico;
    }
    carregandoHistorico = false;
  }

  function selecionarPlano(planoId) {
    planoSelecionado = planoId;
  }

  function obterPlanoAtual() {
    if (planos.length === 0) {
      return null;
    }

    return planos.find((plano) => plano.id === planoSelecionado) || planos[0];
  }

  function formatarValor(valor) {
    return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  }

  function formatarTipoPagamento(tipo) {
    if (tipo === 'renovacao_90') return 'Créditos: 90 dias';
    if (tipo === 'renovacao_180') return 'Créditos: 180 dias';
    if (tipo === 'renovacao_365') return 'Créditos: 365 dias';
    if (tipo === 'renovacao') return 'Créditos: 31 dias';
    if (tipo === 'adesao') return 'Créditos';
    return tipo || 'Créditos';
  }

  async function renovarAssinatura() {
    const planoAtual = planos.find((plano) => plano.id === planoSelecionado);

    if (!planoAtual) {
      alert('Selecione um pacote de créditos antes de continuar.');
      return;
    }

    const cpfLimpo = String(cpfCompra || '').replace(/\D/g, '');
    if (!cpfLimpo) {
      alert('Informe seu CPF para concluir a compra de créditos.');
      return;
    }

    isLoading = true;
    const conexao = new Conexoes();

    const resCpf = await conexao.conecta(Constantes.api_atualizar_tenant, {
      body: {
        id_tenant: tenant.id,
        cpf: cpfLimpo
      }
    });

    if (!resCpf || !resCpf.sucesso) {
      isLoading = false;
      alert('Não foi possível salvar seu CPF no cadastro. Tente novamente.');
      return;
    }

    tenant = { ...tenant, cpf: cpfLimpo };

    const res = await conexao.conecta(Constantes.api_pix_create_payment, {
      id_tenant: tenant.id,
      nome: tenant.nome,
      email: tenant.email,
      cpf: tenant.cpf || cpfLimpo,
      plan_id: planoAtual.id
    });
    isLoading = false;

    if (res && res.id) {
      const transactionData = res.point_of_interaction && res.point_of_interaction.transaction_data
        ? res.point_of_interaction.transaction_data
        : null;

      const amountPix = res.transaction_amount || res.amount || 0;

      montarEEnviarPix(
        res.id,
        transactionData ? transactionData.qr_code_base64 : '',
        transactionData ? transactionData.qr_code : '',
        amountPix,
        res.date_of_expiration,
        res.date_created,
        planoAtual
      );
    } else {
      alert('Falha ao gerar o código PIX. Tente novamente.');
      console.error(res);
    }
  }

  async function retomarPagamento(pag) {
    isLoading = true;
    const conexao = new Conexoes();
    const res = await conexao.conecta(Constantes.api_consultar_pix, {
      transaction_id: pag.transaction_id
    });
    isLoading = false;

    if (res && res.status === 'pending') {
      montarEEnviarPix(pag.transaction_id, res.qr_code_base64, res.qr_code, res.amount || pag.valor);
    } else if (res && res.status === 'approved') {
      alert('Ótima notícia! Este pagamento já consta como aprovado no banco de dados.');
      buscarHistorico();
      buscarCuponsResgatados();
    } else {
      alert('Este PIX já expirou (ele vale por 10 minutos). Escolha os dias e gere um novo PIX.');
    }
  }

  function montarEEnviarPix(trans_id, base64, copiaCola, valor, expiracao = '', criadoEm = '', plano = null) {
    const pixPayload = {
      transaction_id: trans_id,
      qrCodeBase64: base64 || '',
      copiaCola: copiaCola || '',
      amount: Number(valor || 0),
      description: plano ? `Créditos Hora na Mão: ${plano.dias} dias de acesso` : 'Créditos Hora na Mão',
      expiration: expiracao,
      createdAt: criadoEm
    };
    localStorage.setItem('pixPaymentData', JSON.stringify(pixPayload));
    navigate('/pix');
  }

  function formatarData(dataString) {
    if (!dataString) return '-';
    const d = new Date(dataString);
    return d.toLocaleDateString('pt-BR') + ' às ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  // O PIX do Mercado Pago vale 10 minutos (create_payment.php). Depois disso o status no banco continua "pending",
  // então tratamos como expirado para não mostrar "Aguardando PIX" e "Pagar" para sempre.
  function pixExpirado(pag) {
    if (pag.status !== 'pending' || !pag.criado_em) return false;
    const criado = new Date(String(pag.criado_em).replace(' ', 'T'));
    return !isNaN(criado) && (Date.now() - criado.getTime()) > 15 * 60 * 1000;
  }

  function formatarStatus(status) {
    const statusMap = {
      approved: { texto: 'Aprovado', cor: '#38a169', bg: '#e6f4ea' },
      pending: { texto: 'Aguardando PIX', cor: '#d69e2e', bg: '#fefcbf' },
      rejected: { texto: 'Recusado', cor: '#e53e3e', bg: '#fed7d7' },
      cancelled: { texto: 'Cancelado', cor: '#718096', bg: '#edf2f7' }
    };
    return statusMap[status] || { texto: status, cor: '#718096', bg: '#edf2f7' };
  }
</script>

<div class="creditos-container">
  <div class="card-painel">
    <div class="header-card">
      <h2><i class="fas fa-coins text-accent"></i> Meus créditos</h2>
      <p class="text-muted">Cada compra soma dias de acesso à sua agenda. Você compra por PIX só quando quiser: sem mensalidade, sem fidelidade e sem renovação automática.</p>
    </div>
    
    <div class="box-destaque">
      <div class="info-dias">
        <h4 class="text-muted">{tenant?.em_teste ? 'Teste grátis: dias restantes' : 'Dias de acesso restantes'}</h4>
        <h1 class="dias-numero {tenant?.dias_restantes <= 5 ? 'perigo' : ''}">
          {tenant?.dias_restantes || 0} <span>dias</span>
        </h1>
      </div>

      <div class="conteudo-compra">
        <div class="planos-grid">
          {#if carregandoPlanos}
            <div class="mensagem-planos">Carregando pacotes...</div>
          {:else if planos.length === 0}
            <div class="mensagem-planos">Não foi possível carregar os pacotes no momento.</div>
          {:else}
            {#each planosComDesconto as plano}
              <button
                type="button"
                class="plano-card {plano.id === planoSelecionado ? 'ativo' : ''}"
                on:click={() => selecionarPlano(plano.id)}
              >
                <span class="plano-dias">{plano.dias} dias</span>
                {#if ehClienteNovo && plano.temDescontoClienteNovo}
                  <div class="preco-desconto-inline">
                    <span class="preco-original">R$ {formatarValor(plano.valor)}</span>
                    <span class="por-text"> por </span>
                    <strong class="preco-desconto-valor">R$ {formatarValor(plano.valorComDesconto)}<sup class="asterisco">*</sup></strong>
                  </div>
                {:else}
                  <strong>R$ {formatarValor(plano.valor)}</strong>
                {/if}
                <span>{plano.label}</span>
              </button>
            {/each}
          {/if}
        </div>

        {#if ehClienteNovo}
          <div class="info-adesao">* Valor promocional válido apenas para a primeira compra.</div>
        {/if}

        <div class="campo-cpf-compra">
          <label for="cpf-compra">CPF para gerar o pagamento *</label>
          <input id="cpf-compra" type="text" bind:value={cpfCompra} placeholder="Apenas números" maxlength="14" />
          <small>Este CPF é salvo no seu cadastro e pode ser corrigido sempre que quiser.</small>
        </div>

        <button on:click={renovarAssinatura} disabled={isLoading || carregandoPlanos } class="btn-renovar">
          {#if isLoading}
            <i class="fas fa-spinner fa-spin"></i> Processando...
          {:else if planoAtual}
            <i class="fas fa-bolt"></i> Comprar {planoAtual.dias} dias com PIX
          {:else}
            <i class="fas fa-bolt"></i> Comprar créditos com PIX
          {/if}
        </button>
      </div>
    </div>
  </div>

  <div class="cupom-box mt-4">
    <h4><i class="fas fa-ticket-alt"></i> Possui um cupom?</h4>
    <p class="text-muted">Insira seu código promocional para resgatar dias adicionais de acesso ou descontos.</p>
    
    <div class="cupom-input-group">
      <input 
        type="text" 
        bind:value={codigoCupom} 
        placeholder="Digite o código aqui" 
        class="input-modern"
        style="text-transform: uppercase;"
      />
      <button class="btn-primary" on:click={aplicarCupom} disabled={loadingCupom || !codigoCupom}>
        {#if loadingCupom}
          <i class="fas fa-spinner fa-spin"></i>
        {:else}
          Resgatar
        {/if}
      </button>
    </div>

    {#if mensagemCupom}
      <div class="msg-retorno {sucessoCupom ? 'sucesso' : 'erro'}">
        <i class="fas {sucessoCupom ? 'fa-check-circle' : 'fa-exclamation-circle'}"></i> {mensagemCupom}
      </div>
    {/if}

    {#if !carregandoCupons && historicoCupons.length > 0}
      <div class="cupons-resgatados mt-4">
        <h5 class="text-muted mb-2"><i class="fas fa-history"></i> Seus Cupons Resgatados</h5>
        <div class="table-responsive">
          <table class="tabela-mini">
            <thead>
              <tr>
                <th>Código</th>
                <th>Benefício</th>
                <th>Status</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {#each historicoCupons as cupom}
                <tr>
                  <td><strong>{cupom.codigo}</strong></td>
                  <td>
                    {#if parseFloat(cupom.valor_desconto) > 0}
                      Desconto de R$ {parseFloat(cupom.valor_desconto).toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                    {:else}
                      +{cupom.dias_credito} dias grátis
                    {/if}
                  </td>
                  <td>
                    <span class="badge-status-mini {cupom.status}">
                      {cupom.status === 'pendente' ? 'Aguardando PIX' : 'Utilizado'}
                    </span>
                  </td>
                  <td>{formatarData(cupom.data_resgate)}</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
  </div>

  <div class="card-painel mt-4">
    <div class="header-card">
      <h3><i class="fas fa-history text-muted"></i> Histórico de compras</h3>
    </div>

    <div class="table-responsive">
      <table class="tabela-historico">
        <thead>
          <tr>
            <th>Data da Fatura</th>
            <th>Tipo</th>
            <th>Valor</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {#if carregandoHistorico}
            <tr><td colspan="5" class="text-center py-4"><i class="fas fa-spinner fa-spin text-muted"></i> Carregando histórico...</td></tr>
          {:else if historico.length === 0}
            <tr><td colspan="5" class="text-center py-4 text-muted">Nenhum pagamento encontrado.</td></tr>
          {:else}
            {#each historico as pag}
              {@const expirado = pixExpirado(pag)}
              {@const confStatus = expirado ? { texto: 'PIX expirado', cor: '#718096', bg: '#edf2f7' } : formatarStatus(pag.status)}
              <tr>
                <td>{formatarData(pag.criado_em)}</td>
                <td>{formatarTipoPagamento(pag.tipo)}</td>
                <td>R$ {parseFloat(pag.valor).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</td>
                <td>
                  <span class="badge-status" style="color: {confStatus.cor}; background: {confStatus.bg};">
                    {confStatus.texto}
                  </span>
                </td>
                <td>
                  {#if pag.status === 'pending' && !expirado}
                    <button on:click={() => retomarPagamento(pag)} class="btn-retomar" disabled={isLoading} title="Abrir QR Code">
                      <i class="fas fa-qrcode"></i> Pagar
                    </button>
                  {:else}
                    <span class="text-muted">-</span>
                  {/if}
                </td>
              </tr>
            {/each}
          {/if}
        </tbody>
      </table>
    </div>
  </div>
</div>

<style>
  .creditos-container { max-width: 900px; margin: 0 auto; font-family: 'Urbanist', sans-serif; }
  .card-painel { background: white; padding: 30px; border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,0.04); border: 1px solid #e0e6e2; }
  .mt-4 { margin-top: 25px; }
  .mb-2 { margin-bottom: 15px; }
  .text-muted { color: #5a7063; }
  .text-accent { color: #cfaa6c; }
  .text-center { text-align: center; }
  .py-4 { padding: 20px 0; }
  .header-card h2, .header-card h3 { margin: 0 0 5px 0; color: #4a6c56; font-weight: 800; }
  .header-card p { margin: 0; font-size: 0.95rem; }

  .box-destaque { background: #eef5f0; padding: 25px 30px; border-radius: 12px; margin-top: 25px; display: flex; justify-content: space-between; align-items: flex-start; gap: 24px; border-left: 4px solid #4a6c56; flex-wrap: wrap; }
  .info-dias { flex: 1 1 180px; }
  .info-dias h4 { margin: 0; font-weight: 600; font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.5px; }
  .dias-numero { margin: 5px 0 0 0; color: #4a6c56; font-size: 3rem; font-weight: 800; line-height: 1; }
  .dias-numero span { font-size: 1.2rem; font-weight: 600; color: #5a7063; }
  .dias-numero.perigo { color: #e53e3e; }

  .conteudo-compra { flex: 1 1 320px; display: flex; flex-direction: column; gap: 16px; }
  .campo-cpf-compra { display: flex; flex-direction: column; gap: 6px; }
  .campo-cpf-compra label { font-weight: 700; color: #4a6c56; }
  .campo-cpf-compra input { border: 1px solid #d8e2dc; border-radius: 10px; padding: 12px 14px; font-size: 0.95rem; }
  .campo-cpf-compra small { color: #5a7063; font-size: 0.85rem; }
  .planos-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 12px; }
  .plano-card {
    border: 1px solid #c9d6cf;
    border-radius: 12px;
    background: white;
    padding: 14px 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    font-family: inherit;
    cursor: pointer;
    color: #1f2d24;
    transition: 0.2s ease;
    text-align: left;
  }
  .plano-card:hover { border-color: #4a6c56; transform: translateY(-1px); }
  .plano-card.ativo { border-color: #4a6c56; background: #f1f7f1; box-shadow: 0 8px 18px rgba(74, 108, 86, 0.12); }
  .plano-dias { font-size: 0.8rem; color: #5a7063; text-transform: uppercase; letter-spacing: 0.5px; }
  .mensagem-planos { color: #5a7063; font-size: 0.95rem; }

  .btn-renovar { background: #cfaa6c; color: white; border: none; padding: 16px 28px; border-radius: 10px; font-weight: 800; font-size: 1.05rem; cursor: pointer; transition: 0.2s; font-family: inherit; align-self: flex-start; }
  .btn-renovar:hover:not(:disabled) { background: #b8955a; transform: translateY(-2px); box-shadow: 0 5px 15px rgba(207, 170, 108, 0.3); }
  .btn-renovar:disabled { opacity: 0.7; cursor: not-allowed; }
  .btn-renovar:disabled { opacity: 0.7; cursor: not-allowed; }

  .table-responsive { overflow-x: auto; margin-top: 20px; }
  .tabela-historico { width: 100%; border-collapse: collapse; text-align: left; }
  .tabela-historico th { background: #f8faf9; color: #5a7063; font-weight: 700; padding: 15px 20px; font-size: 0.85rem; text-transform: uppercase; border-bottom: 2px solid #e0e6e2; }
  .tabela-historico td { padding: 18px 20px; border-bottom: 1px solid #e0e6e2; color: #1a2a20; font-weight: 600; font-size: 0.95rem; }
  .tabela-historico tbody tr:hover { background: #fdfdfd; }
  
  .badge-status { padding: 6px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; }

  .btn-retomar { background: #4a6c56; color: white; border: none; padding: 6px 12px; border-radius: 6px; font-size: 0.85rem; font-weight: 700; cursor: pointer; transition: 0.2s; }
  .btn-retomar:hover:not(:disabled) { background: #3a5443; }
  .btn-retomar:disabled { opacity: 0.6; cursor: not-allowed; }

  @media (max-width: 768px) {
    .box-destaque { flex-direction: column; text-align: center; gap: 20px; }
  }

  @media (max-width: 640px) {
    .card-painel { padding: 20px 16px; }
    .box-destaque { padding: 20px 16px; }
    .btn-renovar { width: 100%; }
    .cupom-input-group { flex-direction: column; }
    .cupom-input-group .btn-primary { width: 100%; padding: 14px 20px; }
    .dias-numero { font-size: 2.4rem; }
  }

  .cupom-box { background: #ffffff; border: 1px dashed var(--primary); padding: 25px; border-radius: 12px; margin-bottom: 30px; }
  .cupom-box h4 { color: var(--primary); font-weight: 800; margin-bottom: 5px; display: flex; align-items: center; gap: 10px; }

  .cupom-input-group { display: flex; gap: 15px; margin-top: 15px; }
  .cupom-input-group .input-modern { flex: 1; font-weight: 700; letter-spacing: 1px; }
  .cupom-input-group .btn-primary { padding: 0 25px; white-space: nowrap; }

  .msg-retorno { margin-top: 15px; padding: 10px 15px; border-radius: 8px; font-weight: 600; font-size: 0.9rem; animation: fadeIn 0.3s; }
  .msg-retorno.sucesso { background: #eef5f0; color: #4a6c56; border: 1px solid #cce0d2; }
  .msg-retorno.erro { background: #fed7d7; color: #c53030; border: 1px solid #feb2b2; }

  /* ESTILOS DA NOVA TABELA MINI DE CUPONS */
  .cupons-resgatados h5 { font-size: 0.95rem; font-weight: 700; }
  .preco-desconto-inline { display: flex; flex-direction: column; align-items: flex-start; gap: 0; }
  .preco-desconto-inline .por-text { display: none; }
  .preco-original { text-decoration: line-through; color: #8a9a8f; font-size: 0.95rem; }
  .por-text { color: #5a7063; font-weight: 700; }
  .preco-desconto-valor { color: #2f855a; font-size: 1.05rem; white-space: nowrap; }
  .asterisco { font-size: 0.6rem; margin-left: 4px; vertical-align: super; color: #2f855a; }
  .info-adesao { font-size: 0.85rem; color: #5a7063; margin-top: 8px; }
  .tabela-mini { width: 100%; border-collapse: collapse; text-align: left; font-size: 0.85rem; }
  .tabela-mini th { background: transparent; color: #738a7c; font-weight: 700; padding: 10px 15px; text-transform: uppercase; border-bottom: 1px solid #e0e6e2; }
  .tabela-mini td { padding: 12px 15px; border-bottom: 1px solid #f0f4f2; color: #2c3e34; }
  .tabela-mini tr:last-child td { border-bottom: none; }
  
  .badge-status-mini { padding: 4px 8px; border-radius: 6px; font-weight: 700; font-size: 0.75rem; }
  .badge-status-mini.pendente { background: #fefcbf; color: #d69e2e; }
  .badge-status-mini.usado { background: #edf2f7; color: #718096; }
</style>